import { defineComponent as g, useSlots as w, openBlock as u, createBlock as m, createSlots as f, unref as r, withCtx as s, renderSlot as i, normalizeClass as C, h as S } from "vue";
import k from "./ghl-ui.es279.js";
import B from "./ghl-ui.es280.js";
import c from "./ghl-ui.es281.js";
const p = g({
  name: "UIColorPicker",
  inheritAttrs: !1,
  components: { NColorPicker: c }
}), A = g({
  ...p,
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    compact: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: void 0
    },
    enableAlpha: {
      type: Boolean,
      default: !0
    },
    defaultShow: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    modes: {
      type: Array,
      default: void 0
    },
    customTrigger: {
      type: Function,
      default: void 0
    },
    defaultValue: {
      type: String,
      default: "#000"
    },
    value: {
      type: String,
      default: null
    },
    swatches: {
      type: Array,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    trigger: {
      type: String,
      default: "click",
      description: "trigger for swatches type"
    },
    brandColors: {
      type: Array,
      default: void 0
    },
    baseColors: {
      type: Array,
      default: () => ["#FFFFFFFF", "#000000FF"]
    },
    brandColorPlacement: {
      type: String,
      default: "bottom-end"
    },
    disableBrandSection: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "onComplete",
    "update:value",
    "route:brand-boards",
    "update:show",
    "onRemoveColor",
    "onAddColor",
    "onChangeColor"
  ],
  setup(e, { emit: b }) {
    const n = w(), d = e, y = {
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      outline: "#00000069 solid 1px",
      padding: "2px",
      border: "1px solid var(--gray-300)"
    }, h = {
      borderRadius: "0.5rem",
      border: "1px solid var(--gray-300)",
      width: "2rem",
      height: "2rem"
    }, v = (o) => {
      if (d.compact || d.type === "compact" || d.type === "square") {
        const t = d.type === "square" ? h : y;
        return S("div", {
          class: "ghl-color-preview",
          style: {
            ...t,
            backgroundColor: o ?? d.defaultValue
          }
        });
      }
    }, l = b;
    return (o, t) => e.type === "swatches" ? (u(), m(B, {
      key: 0,
      show: e.show,
      disabled: e.disabled,
      swatches: e.swatches,
      value: e.value,
      placement: e.placement,
      trigger: e.trigger,
      onOnClickColor: t[0] || (t[0] = (a) => l("update:value", a))
    }, f({ _: 2 }, [
      r(n).header ? {
        name: "header",
        fn: s(() => [
          i(o.$slots, "header")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["show", "disabled", "swatches", "value", "placement", "trigger"])) : e.type === "brand-colors" ? (u(), m(k, {
      key: 1,
      "brand-colors": e.brandColors,
      "default-value": e.defaultValue,
      value: e.value,
      placement: e.placement,
      brandColorPlacement: e.brandColorPlacement,
      defaultLabel: "Default",
      "palette-trigger": e.customTrigger,
      swatches: e.swatches,
      show: e.show,
      disabled: e.disabled,
      trigger: e.trigger,
      to: e.to,
      showAlpha: e.enableAlpha,
      baseColors: e.baseColors,
      disableBrandSection: e.disableBrandSection,
      "onUpdate:value": t[1] || (t[1] = (a) => l("update:value", a)),
      "onUpdate:show": t[2] || (t[2] = (a) => l("update:show", a)),
      "onRoute:brandBoards": t[3] || (t[3] = (a) => l("route:brand-boards")),
      onOnRemoveColor: t[4] || (t[4] = (a) => l("onRemoveColor", a)),
      onOnAddColor: t[5] || (t[5] = (a) => l("onAddColor", a)),
      onOnChangeColor: t[6] || (t[6] = (a) => l("onChangeColor", a))
    }, f({ _: 2 }, [
      r(n).header ? {
        name: "header",
        fn: s(() => [
          i(o.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      r(n).trigger ? {
        name: "trigger",
        fn: s(() => [
          i(o.$slots, "trigger")
        ]),
        key: "1"
      } : void 0,
      r(n).action ? {
        name: "action",
        fn: s(() => [
          i(o.$slots, "action")
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["brand-colors", "default-value", "value", "placement", "brandColorPlacement", "palette-trigger", "swatches", "show", "disabled", "trigger", "to", "showAlpha", "baseColors", "disableBrandSection"])) : (u(), m(r(c), {
      key: 2,
      class: C(
        e.compact || e.customTrigger || e.type === "compact" || e.type === "square" ? "compact-picker" : ""
      ),
      placement: e.placement,
      "render-label": e.customTrigger ?? v,
      value: e.value,
      "default-value": e.defaultValue,
      "default-show": e.defaultShow,
      show: e.show,
      "show-alpha": e.enableAlpha,
      to: e.to,
      disabled: e.disabled,
      swatches: e.swatches,
      modes: e.modes,
      onComplete: t[7] || (t[7] = (a) => l("onComplete", a)),
      "onUpdate:value": t[8] || (t[8] = (a) => l("update:value", a))
    }, null, 8, ["class", "placement", "render-label", "value", "default-value", "default-show", "show", "show-alpha", "to", "disabled", "swatches", "modes"]));
  }
}), T = A;
export {
  T as default
};
